export default "__VITE_ASSET__1894e8b1__"